module.exports = "td {\n  padding-left: 5px; }\n\n.results-right {\n  text-align: right; }\n"